import styled from "styled-components";
import { colors, fonts, media } from "../../style/constants";

export const Section = styled.section`
  ${media.md`

  `}

  ${media.sm`

  `}
`;

export const FormCard = styled.form`
  ${media.md`

  `}

  ${media.sm`

  `}

  & > * + * {
  }
`;

export const Title = styled.a``;

export const Label = styled.label``;

export const Input = styled.input`
  margin-top: 0.5rem;
  padding: 0.7rem 0.9rem;
  background: transparent;
  border: 1px solid ${colors.gray500};
  width: 100%;
  color: ${colors.gray500};
  font-family: ${fonts.mono};
  transition:
    border-color 0.2s ease,
    color 0.2s ease;

  &:focus {
    outline: none;
    border-color: ${colors.red500};
  }

  &::placeholder {
    color: ${colors.gray500};
  }
`;

export const Button = styled.button`
  margin-top: 0.5rem;
  border: none;
  background: transparent;
  color: ${colors.red500};
  border: ${colors.red500} solid 1px;
  font-family: ${fonts.mono};
  padding: 0.75rem 1.5rem;
  align-self: flex-start;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition:
    transform 0.2s ease,
    opacity 0.2s ease;

  &:hover,
  &:focus {
    /*transform: translateY(-1px);*/
  }

  &:disabled {
    opacity: 0.6;
    cursor: wait;
    transform: none;
  }
`;

export const Message = styled.p`
  color: ${colors.gray500};
  margin: 1rem 0 0 0;
`;

export const Honeypot = styled.p`
  position: absolute;
  left: -9999px;
  opacity: 0;
  height: 0;
  width: 1px;
  overflow: hidden;
`;



// WEBPACK FOOTER //
// ./src/components/SubscribeForm/style.js